export default function() {
    return <div>Network Error</div>
}